module.exports = __webpack_public_path__ + "static/media/linkedin-2020-skills.d1fef405.jpg";